import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue')
const Boxes = () => import(/* webpackChunkName: "boxes" */ '@/views/Boxes.vue')
const Products = () => import(/* webpackChunkName: "products" */ '@/views/Products.vue')
const Drafts = () => import(/* webpackChunkName: "drafts" */ '@/views/Drafts.vue')
const Subscriptions = () => import(/* webpackChunkName: "subscriptions" */ '@/views/Subscriptions.vue')
const Trackers =  () => import(/* webpackChunkName: "Trackers" */ '@/views/Trackers.vue')
const Shipments =  () => import(/* webpackChunkName: "Shipments" */ '@/views/Shipments.vue')
const Returns =  () => import(/* webpackChunkName: "returns" */ '@/views/Returns.vue')
const Email = () => import(/* webpackChunkName: "email" */ '@/views/Email.vue')
const Settings =  () => import(/* webpackChunkName: "settings" */ '@/views/Settings.vue')
const Users = () => import(/* webpackChunkName: "users" */ '@/views/Users.vue')
const Analytics = () => import(/* webpackChunkName: "analytics" */ '@/views/Analytics.vue')
const Billing = () => import(/* webpackChunkName: "analytics" */ '@/views/Billing.vue')
const Signin = () => import(/* webpackChunkName: "signin" */ '@/views/Signin.vue')
import AuthGuard from './auth-guard'
import isAtLeastAdmin from './admin-guard'
//import isAtLeastManager from './manager-guard'

//const Signup = () => import(/* webpackChunkName: "signup" */ '@/views/User/Signup')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: '/boxes',
      name: 'boxes',
      component: Boxes,
      beforeEnter: AuthGuard
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      beforeEnter: AuthGuard
    },
    {
      path: '/drafts',
      name: 'drafts',
      component: Drafts,
      beforeEnter: AuthGuard
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions,
      beforeEnter: AuthGuard
    },
    {
      path: '/Trackers',
      name: 'Trackers',
      component: Trackers,
      beforeEnter: AuthGuard
    },
    {
      path: '/Shipments',
      name: 'Shipments',
      component: Shipments,
      beforeEnter: AuthGuard
    },
    {
      path: '/returns',
      name: 'returns',
      component: Returns,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter: AuthGuard
    },
    {
      path: '/email',
      name: 'email',
      component: Email,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'signin',
      component: Signin
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      beforeEnter: isAtLeastAdmin
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics,
      beforeEnter: AuthGuard
    },
    {
      path: '/billing',
      name: 'billing',
      component: Billing,
      beforeEnter: AuthGuard
    }
  ]
})